module.exports = __webpack_public_path__ + "img/rec_tec_grills.6524da80.png";